// Libraries
import { MenuItemType } from 'antd/lib/menu/hooks/useItems';

// Types
import { EquipmentUnitDataVSICrusher } from '../../../../../../types/crusher';
import { EdgeDeviceOperationalStatus } from '../../../../../../types/global';

export enum SetpointType {
  automation = 'automation',
  crusher = 'crusher',
  lubrication = 'lubrication',
  vibration = 'vibration',
}

export type SetpointItemTab = {
  key: SetpointType;
  label: string;
};

export interface SetpointProps {
  className?: string;
  edgeStatus: EdgeDeviceOperationalStatus | null;
  onChangeView: (key: MenuItemType) => void;
  selectedView: SetpointType;
  testId?: string;
  unitData: EquipmentUnitDataVSICrusher | null;
}
